import React from 'react'

import PerfectScrollBar from 'react-perfect-scrollbar'

import { Paper, Switch, makeStyles, CircularProgress } from '@material-ui/core'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import * as service from 'service'
import useFetch from 'hooks/useFetch'
import useContract from 'hooks/useContract'
import Footer from './../Footer'
import styles from './styles'

const useStyles = makeStyles(styles)

const Tax = () => {
  const classes = useStyles()
  const { data, setData, nextStep } = useContract()

  const { response, isLoading } = useFetch(service.recurrence.taxes.get, {
    tax: { active: true },
  })

  const taxChecked = taxId => data.contract.taxes.some(tax => tax.id === taxId)

  const handleChangeTax = (event, tax) => {
    if (event.target.checked) {
      setData(data => ({
        ...data,
        contract: {
          ...data.contract,
          taxes: [...data.contract.taxes, { ...tax }],
        },
      }))

      return
    }

    setData(data => ({
      ...data,
      contract: {
        ...data.contract,
        taxes: [
          ...data.contract.taxes.filter(currentTax => currentTax.id !== tax.id),
        ],
      },
    }))
  }

  const handleClickNextButton = () => nextStep()

  return (
    <>
      <div className={classes.root}>
        {isLoading ? (
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        ) : (
          <Paper>
            <PerfectScrollBar>
              <Table
                size="small"
                emptyMessage="Não há impostos configurados ou ativos"
                noWrap
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>Valor</TableCell>
                    <TableCell>Escopo</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {response &&
                    response.data.taxes.map(tax => (
                      <TableRow key={tax.id}>
                        <TableCell>{tax.name}</TableCell>
                        <TableCell>{tax.value}%</TableCell>
                        <TableCell>{tax.scope}</TableCell>
                        <TableCell align="right">
                          <Switch
                            onChange={event => handleChangeTax(event, tax)}
                            size="small"
                            checked={taxChecked(tax.id)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </PerfectScrollBar>
          </Paper>
        )}
      </div>

      <Footer
        nextButtonText="Continuar"
        nextButtonProps={{
          onClick: handleClickNextButton,
        }}
      />
    </>
  )
}

export default Tax
